import Project from "./Project"
import classes from './Project.module.css'

const ProjectEditor = () => {
    return <Project iframeHeight={"calc(100vh - 120px)"} Comment={<div className={classes.Header} />}>
    </Project>
}
export default ProjectEditor